import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43d5d562"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-main-menu" }
const _hoisted_2 = { class: "d-main-menu__item-text" }
const _hoisted_3 = { class: "d-main-menu__item-text" }
const _hoisted_4 = { class: "badge-wrapper-bell" }
const _hoisted_5 = { class: "d-main-menu__item-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "d-main-menu__item-icon icon icon-group" }, null, -1))
const _hoisted_7 = { class: "d-main-menu__item-text" }
const _hoisted_8 = { class: "d-main-menu__item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_badge = _resolveComponent("app-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: _normalizeClass(["d-main-menu__item", {'d-main-menu__item--active': _ctx.isDrive}]),
      to: "/drive"
    }, {
      default: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass(["d-main-menu__item-icon icon", [_ctx.isDrive ? 'icon-folder-logo-active' : 'icon-folder-logo']])
        }, null, 2),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$localize('footer.drive_tab')), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      class: _normalizeClass(["d-main-menu__item", {'d-main-menu__item--active': _ctx.isMessages}]),
      to: _ctx.currentMessagesRoute
    }, {
      default: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass(["d-main-menu__item-icon icon", [_ctx.isMessages ? 'icon-message-circle-active' : 'icon-message-circle']])
        }, null, 2),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$localize('drive.aside.menu.messages')), 1)
      ]),
      _: 1
    }, 8, ["class", "to"]),
    _createVNode(_component_router_link, {
      class: _normalizeClass(["d-main-menu__item", {'d-main-menu__item--active': _ctx.isAlerts}]),
      to: "/alerts"
    }, {
      default: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass(["d-main-menu__item-icon alert-icon", [_ctx.isAlerts ? 'icon-bell-active' : 'icon-bell']])
        }, null, 2),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_app_badge, {
            number: _ctx.mainStore.badgesAlert
          }, null, 8, ["number"])
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$localize('drive.aside.menu.alerts')), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      class: _normalizeClass(["d-main-menu__item", {'d-main-menu__item--active': _ctx.isContacts}]),
      to: "/spaces/contacts"
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$localize('contacts.title')), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      class: _normalizeClass(["d-main-menu__item", {'d-main-menu__item--active': _ctx.isSettings}]),
      to: "/settings"
    }, {
      default: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass(["d-main-menu__item-icon icon", [_ctx.isSettings ? 'icon-settings2-active' : 'icon-settings2']])
        }, null, 2),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$localize('footer.settings_tab')), 1)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}